<template>
  <div>
    <div class="p-5 bg-white rounded non-print">
      <div class="py-6 text-xl text-center">{{ $t('customer.seller_checkout') }}</div>
      <between-date @onClick="fetchCheckout"></between-date>
      <div class="flex justify-end py-3">
        <v-btn class="blue white--text mx-1" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
        <v-btn class="blue white--text mx-1" @click="printPDF">
          <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
        </v-btn>
        <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportCheckout"
          :disableIcon="true" />
      </div>
      <div class="py-5">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-simple-table class="elevation-1 table-report-checkout data-table-checkout v-data-table-report" id="printarea">
          <thead>
            <tr>
              <th>{{ $t('contract.contract_number_only') }}</th>
              <th>{{ $t('date') }}</th>
              <th>
                <div class="text-nowrap-table customer-name" style="min-width: 80px;">{{ $t('customer.title') }}</div>
              </th>
              <th>
                <div class="text-nowrap-table business-name" style="min-width: 80px;">{{ $t('area.shop_name') }}</div>
              </th>
              <th style="min-width: 70px;">{{ $t('market.market_title') }}</th>
              <th>{{ $t('area.space') }}</th>
              <th>{{ $t('bill.outstanding_bill') }}</th>
              <th>{{ $t('checkout_title') }}</th>
              <th>{{ $t('payment.deposit') }}</th>
              <th>{{ $t('payment.total') }}</th>
              <th style="min-width: 120px;">{{ $t('payment.title') }}</th>
              <th>{{ $t('payment.payment_or_refund_date') }}</th>
              <th>
                <div class="text-nowrap-table customer-name" style="min-width: 80px;">{{ $t('payment.payment_received_by') }}</div>
              </th>
              <th style="min-width: 110px;">{{ $t('contract.checkout_type') }}</th>
              <th style="min-width: 110px;">{{ $t('area.checkout_status') }}</th>
              <th style="min-width: 80px;" class="non-print"></th>
              <th style="min-width: 40px;" class="non-print"></th>
            </tr>
            <tr class="non-print">
              <td class="text-center">
                <v-icon>mdi-filter-multiple-outline</v-icon>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td width="9%">
                <v-select v-model="filterData.checkoutType" :items="filterOption.checkoutType" type="text" :label="$t('contract.checkout_type')" solo dense
                  hide-details clearable width="30px" :no-data-text="$t('noinfo')"/>
              </td>
              <td width="9%">
                <v-select v-model="filterData.status" :items="filterOption.status" type="text" :label="$t('status')" solo dense
                  hide-details clearable width="30px" :no-data-text="$t('noinfo')"/>
              </td>
            </tr>
          </thead>
          <tbody>
            <template v-for="item in filterCheckouts">
              <tr>
                <td>{{ item.contract.contractId || "-" }}</td>
                <td>{{ $moment(item.checkOutDate).format("DD/MM/YYYY") }}</td>
                <td class="hd-resize text-truncate">
                  {{ item.customerData.name }} 
                </td>
                <td class="hd-resize text-truncate">
                  {{ item.contract.businessName }} 
                </td>
                <td>{{ item.summary.filter(d => d.area).length }}</td>
                <td class="number">
                  {{
                    item.areas
                    ? item.areas.reduce((acc, i) => acc + i.size, 0)
                    : "-" | currency
                  }}
                </td>
                <td class="number">
                  <template v-if="item.isSendApproveTask && (item.approveStatus == 'rejected')">-</template>
                  <template v-else>{{ item.unpaidTotalCost | currencyPrefixSign }}</template>
                </td>
                <td class="number">
                  <template v-if="item.isSendApproveTask && (item.approveStatus == 'rejected')">-</template>
                  <template v-else>{{ item.checkOutTotalCost | currencyPrefixSign }}</template>
                </td>
                <td class="number">
                  <template v-if="item.isSendApproveTask && (item.approveStatus == 'rejected')">-</template>
                  <template v-else>{{ item.depositTotalCost - (item.isForfeit ? item.forfeitCost : 0) | currencyPrefixSign
                  }}</template>
                </td>
                <td class="number">
                  <template v-if="item.isSendApproveTask && (item.approveStatus == 'rejected')">-</template>
                  <template v-else>{{ item.totalCostAbs | currencyPrefixSign }}</template>
                </td>
                <td>
                  <template v-if="item.isSendApproveTask && (item.approveStatus == 'rejected')">-</template>
                  <template v-else>
                    <span :class="`px-1 block py-2 text-center rounded-full ${item.isPaidClass.chipCss}`">{{
                      item.isPaidClass.text }}</span>
                  </template>
                </td>
                <td> {{ item.payDate ? $moment(item.payDate).format("DD/MM/YYYY") : "" }} </td>
                <td class="hd-resize text-truncate">
                   {{ item.getReceivedBy || "-" }}
                </td>
                <td class="text-center">
                  {{ item.checkoutType }}
                </td>
                <td>
                  <span :class="`px-1 block py-2 text-center rounded-full ${item.statusClass.css}`">{{
                    item.statusClass.text }}</span>
                </td>
                <td class="non-print">
                  <v-btn
                    v-if="!item.isSendApproveTask || (item.isSendApproveTask && (item.approveStatus == 'approved' || item.approveStatus == 'pending' || item.approveStatus == 'draft'))"
                    @click="getContractCheckoutFn(item)" class="py-2 text-white rounded-full" elevation="0"
                    color="grey lighten-4" rounded>{{ $t('detail') }}</v-btn>
                </td>
                <td class="non-print">
                  <v-btn v-if="!item.isSendApproveTask || (item.isSendApproveTask && item.approveStatus == 'approved')"
                    icon @click="item.expend = !item.expend">
                    <v-icon>
                      {{
                        item.expend ? "mdi-chevron-up" : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              <template v-if="item.expend">
                <tr v-for="sum in item.summary">
                  <td align="left"></td>
                  <td align="left"></td>
                  <td align="left"></td>
                  <td align="left"></td>
                  <td align="center">
                    <div class="text-nowrap-table area-name">
                      {{ sum.area ? sum.area.name : sum.isForfeit ? $t('payment.forfeit_deposit_money') : $t('other') }}
                    </div>
                  </td>
                  <td class="number">
                    <span v-if="sum.isForfeit">-</span>
                    <span v-else-if="sum.area"> {{ sum.area.size | currency }} </span>
                    <span v-else>-</span>
                  </td>
                  <td class="number">{{ sum.unpaidTotalCost | currencyPrefixSign }}</td>
                  <td class="number">{{ sum.checkOutTotalCost | currencyPrefixSign }}</td>
                  <td class="number">{{ sum.isForfeit ? sum.forfeitCost : sum.depositTotalCost | currencyPrefixSign }}</td>
                  <td class="number">
                    <div class="py-2">{{ summary(sum).total | currencyPrefixSign }}</div>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </template>
            </template>
          </tbody>
        </v-simple-table>
      </div>
    </div>
    <checkout-payment2 v-model="isCheckoutPayment" @onSuccess="fetchCheckout" @onSuccessCheckout="fetchCheckout"
      :isCreate="true"></checkout-payment2>
    <CheckoutDialog v-model="isContractCheckOutDialog" :contractCheckOutId="contractCheckOutId"
      @onSaveSuccess="onContractCheckOutSaveSuccess"
      :method="(tempContractCheckOut && tempContractCheckOut.isSendApproveTask && (tempContractCheckOut.approveStatus == 'pending' || tempContractCheckOut.approveStatus == 'rejected')) ? 'view' : 'edit'"
      :isClearDebt="true" />
    <v-dialog v-model="isCheckoutLoading" persistent max-width="500px">
      <v-card height="250">
        <!-- v-overlay -->
        <v-overlay color="white" :absolute="true">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BetweenDate from "./BetweenDate.vue";
import CheckoutPayment2 from "./CheckoutPayment.vue";
import CheckoutDialog from "./CheckoutDialog.vue";
import FilterColumnDataTable from "@/components/FilterColumnDataTable.vue"
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { Excel } from "../exports";
export default {
  components: { BetweenDate, CheckoutPayment2, CheckoutDialog, FilterColumnDataTable },
  computed: {
    ...mapState({
      checkouts: state => state.contractCheckout.checkouts
    }),
    ...mapGetters({
      getFullName: "user/getFullName",
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    userFullName() {
      return this.getFullName;
    },
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    filterCheckouts() {
      let list = this.checkouts
      if (this.filterData.status) {
        list = list.filter(
          d => d.statusClass.text == this.filterData.status
        );
      }
      if (this.filterData.checkoutType) {
        list = list.filter(
          d => d.checkoutType == this.filterData.checkoutType
        );
      }
      return list;
    },
    dataTable() {
      return {
        headers: this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : [], // filter(h=>h.isShow == true)
        data: this.contracts && this.contracts.length ? this.contracts : [] // filter(c => c.isActive == true)
      }
    }
  },
  created: function () {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }
    this.intiDataTable()
    this.fetchCheckout();
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      date: {
        startDate: this.$moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        endDate: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      headers: [
        {
          text: this.$t('contract.contract_number_only'),
          align: "left",
          value: "contract.contractId",
          width: "8%"
        },
        {
          text: this.$t('date'),
          align: "left",
          value: "date",
          width: "8%"
        },
        {
          text: this.$t('customer.title'),
          align: "left",
          value: "customerData.name",
          width: "1%"
        },
        {
          text: this.$t('area.shop_name'),
          align: "left",
          value: "contract.businessName",
          width: "1%"
        },
        {
          text: this.$t('market.market_title'),
          align: "center",
          value: "areas",
          width: "8%"
        },
        {
          text: this.$t('area.space'),
          align: "left",
          value: "areaSize",
          width: "5%",
          sortable: false
        },
        {
          text: this.$t('bill.outstanding_bill'),
          align: "left",
          value: "unpaidTotalCost",
          width: "8%"
        },
        {
          text: this.$t('checkout_title'),
          align: "left",
          value: "checkOutTotalCost",
          width: "8%"
        },
        {
          text: this.$t('payment.deposit'),
          align: "left",
          value: "depositTotalCost",
          width: "8%"
        },
        {
          text: this.$t('payment.forfeit_deposit_money'),
          align: "left",
          value: "forfeitCost",
          width: "8%"
        },
        {
          text: this.$t('payment.received_payment_by'),
          align: "left",
          value: "getReceivedBy",
          width: "6%",
          sortable: false
        },
        {
          text: this.$t('payment.total'),
          align: "left",
          value: "cost",
          width: "10%"
        },
        {
          text: this.$t('payment.title'),
          align: "left",
          value: "sumStatus",
          width: "8%"
        },
        {
          text: this.$t('area.checkout_status'),
          value: "status",
          align: "center",
          // width: "10%"
        },
        {
          text: "",
          align: "left",
          value: "actions"
        },
        { text: "", value: "data-table-expand" }
      ],
      search: "",
      page: 1,
      rowsPerPage: 50,
      loading: false,
      isCheckoutPayment: false,
      isCheckoutLoading: false,
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      isContractCheckOutDialog: false,
      contractCheckOutId: null,
      tempContractCheckOut: null,
      filterData: {
        status: "",
        checkoutType: ""
      },
      filterOption: {
        status: [
          {
            text: this.$t('area.status_already_checkout')
          },
          {
            text: this.$t('area.status_wait_checkout')
          },
          {
            text: this.$t('task.status_wait_approve_checkout')
          },
          {
            text: this.$t('task.not_approve')
          },
          {
            text: this.$t('draft')
          },
          {
            text: this.$t('cancel')
          }
        ],
        checkoutType: [
          {
            text: this.$t('contract.close_contract')
          },
          {
            text: this.$t('contract.reduce_area')
          },
          {
            text: this.$t('contract.escaped')
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions({
      getContractCheckout: "contractCheckout/getContractCheckout",
      getContractCheckoutsBetweenDateByMarket: "contractCheckout/getContractCheckoutsBetweenDateByMarket"
    }),
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportCheckout'] ? filterDataTable['ReportCheckout'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async exportExcel() {
      try {
        await Excel.generateExcel2(
          this.checkouts,
          this.startDate,
          this.endDate
        );
      } catch (e) { }
    },
    summary(sum) {
      const total = (sum.depositTotalCost + sum.forfeitCost) - (sum.unpaidTotalCost + sum.checkOutTotalCost);
      // const abs = Math.abs(total);
      const sign = total < 0 ? "-" : total > 0 ? "+" : 0;
      return { total: total, sign };
    },
    async getContractCheckoutFn(item) {
      try {
        this.isCheckoutLoading = true;
        const id = item.objectId;
        this.tempContractCheckOut = item;
        if (item.isNotClearDebt) {
          this.contractCheckOutId = id;
          this.isContractCheckOutDialog = true;
        } else {
          await this.getContractCheckout({ id });
          this.isCheckoutPayment = true;
        }
        this.isCheckoutLoading = false;
      } catch (e) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async onContractCheckOutSaveSuccess(item) {
      await this.fetchCheckout();
      try {
        if (item && item.objectId) {
          this.isCheckoutLoading = true;
          const id = item.objectId;
          await this.getContractCheckout({ id });
          this.isCheckoutPayment = true;
          this.isCheckoutLoading = false;
        }
      } catch (e) {
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async fetchCheckout(value) {
      if (this.marketId && this.marketId != "") {
        this.loading = true;
        this.selected = [];
        await this.getContractCheckoutsBetweenDateByMarket({
          marketId: this.marketId,
          startDate: value?.startDate || this.$moment(this.startDate).startOf("day").toISOString(),
          endDate: value?.endDate || this.$moment(this.endDate).endOf("day").toISOString()
        }
        );
        if (value?.startDate && value?.endDate) {
          this.startDate =
            this.$moment(value?.startDate).format("YYYY-MM-DD") ||
            this.$moment()
              .startOf("month")
              .format("YYYY-MM-DD");
          this.endDate =
            this.$moment(value?.endDate).format("YYYY-MM-DD") ||
            this.$moment()
              .endOf("month")
              .format("YYYY-MM-DD");
        }
        // console.log(this.checkouts)
        this.loading = false;
      }
    },
    printPDF() {
      let printarea = document.getElementById("printarea").innerHTML;
      let printPreviewTopic = document.getElementById("print-preview-topic");
      let printPreviewcontent = document.getElementById(
        "print-preview-content"
      );
      let printPreviewFooter = document.getElementById("print-preview-footer");

      printPreviewTopic.innerHTML = `
        <h2 style="text-align: center;" class="my-4">
          <b>${this.$t('customer.seller_checkout')}</b>
        </h2>
        <p style="text-align: center;">${this.market.name}</p>
        <p style="text-align: center;">
          ${this.$moment(this.startDate, "YYYY-MM-DD").format(
        "D MMMM YYYY"
      )} - ${this.$moment(this.endDate, "YYYY-MM-DD").format("D MMMM YYYY")}
        </p>
      `;
      printPreviewcontent.innerHTML = printarea;
      printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')} : </b>${this.userFullName
        } <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`;
      window.print();
    }
  }
};
</script>

<style lang="scss" scoped>
.table-report-checkout {
  table {
    thead {
      tr {
        th {
          text-align: center !important;
        }

        // td {}
      }
    }

    tbody {
      tr {
        td {
          text-align: center !important;
          padding: 0 10px;
        }

        td.number {
          text-align: right !important;
          white-space: nowrap;
        }
      }
    }
  }
}

.number{
  white-space: nowrap;
}

.simple th+td {
  @apply border-gray-100;
}

.data-table-checkout::v-deep td {
  max-width: 250px;
}

.data-table-checkout::v-deep td.hd-resize {
  max-width: 80px;
}

</style>